import { render, staticRenderFns } from "./BatchLotUpV2.vue?vue&type=template&id=370d6c8e&scoped=true"
import script from "./BatchLotUpV2.vue?vue&type=script&lang=js"
export * from "./BatchLotUpV2.vue?vue&type=script&lang=js"
import style0 from "./BatchLotUpV2.vue?vue&type=style&index=0&id=370d6c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370d6c8e",
  null
  
)

export default component.exports